module.exports = __webpack_public_path__ + "img/get-pocket.82084c92.svg";